"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StereoPlanRouteMock = void 0;
const uuid_1 = require("uuid");
const stereo_plan_route_model_1 = require("./stereo-plan-route.model");
const attachment_file_1 = require("../attachment-file");
class StereoPlanRouteMock extends stereo_plan_route_model_1.StereoPlanRoute {
    constructor(data) {
        const title = StereoPlanRouteMock.generateRandomTitle();
        const route = StereoPlanRouteMock.generateRandomRoute();
        const notes = StereoPlanRouteMock.generateRandomNotes();
        const eventSpecificNotes = StereoPlanRouteMock.generateRandomEventSpecificNotes();
        const seedData = {
            id: (0, uuid_1.v4)(),
            title,
            route,
            notes,
            eventSpecificNotes,
            files: Array.from({ length: Math.floor(Math.random() * 4) + 1 }, () => new attachment_file_1.AttachmentFileMock()),
            squadronId: (0, uuid_1.v4)(),
            ...data,
        };
        super(seedData);
    }
    static generateRandomTitle() {
        const titles = [
            'MPRS CERT',
            'AR TRACK',
            'DEPARTURE ROUTE',
            'ARRIVAL PROCEDURE',
            'TANKER PATTERN',
            'HOLDING PATTERN',
            'REFUELING TRACK',
            'LOW LEVEL ROUTE',
            'COMBAT PATTERN',
            'TRAINING CIRCUIT',
        ];
        return titles[Math.floor(Math.random() * titles.length)];
    }
    static generateRandomRoute() {
        const routeTypes = [
            // Air refueling tracks
            'AR 200',
            'AR 637',
            'AR 105',
            'AR 313',
            // Military training routes
            'W135 F 1-3',
            'W145 F 2-5',
            'IR 715',
            'VR 1102',
            // Military operation areas
            'WHISKEY MOA',
            'ALPHA MOA',
            'DELTA MOA',
            // Waypoint sequences
            'SKYES4 SKYES MZR RODEN 3213.93N/11735.73W 3300.33N/11727.48W',
            'BLUEMTN CRDNL HAARP DELTA5 OSCAR 3018.00N/11719.92W',
            'VIPER6 SNAKE MZB HENSA CEMBO 3038.37N/11736.48W',
        ];
        return routeTypes[Math.floor(Math.random() * routeTypes.length)];
    }
    static generateRandomNotes() {
        const noteTemplates = [
            'A-10 POC: Joe Smith (555) 123-9876\nF-16 POC: Jane Doe (985) 852-6456\n\nAny other applicable notes that current ops may want to put in here to reference.',
            'KC-135 POC: Capt. Richards (555) 787-1212\nF-22 POC: Lt. Johnson (555) 434-8900\n\nEnsure proper authentication procedures for rejoins.',
            'C-17 POC: Maj. Williams (555) 321-4567\nC-130 POC: Capt. Taylor (555) 765-4321\n\nBe advised of potential diplomatic clearance requirements.',
            'E-3 POC: Col. Adams (555) 111-2222\nRC-135 POC: Maj. Evans (555) 333-4444\n\nSensitive collection mission parameters apply.',
        ];
        return noteTemplates[Math.floor(Math.random() * noteTemplates.length)];
    }
    static generateRandomEventSpecificNotes() {
        const noteTemplates = [
            'Notes specific to this Stereo Plan that should be populated into the event.',
            'Exercise BLUE FLAG: Maintain emission control procedures during ingress.',
            'MAKO 22-1: Coordinate with AWACS for picture updates at designated checkpoints.',
            'RED FLAG 23-2: Expect simulated threat emitters along route. Monitor assigned channels for pop-up threats.',
            'RIMPAC 2023: Be advised of international exercise airspace restrictions and ROE differences.',
        ];
        return noteTemplates[Math.floor(Math.random() * noteTemplates.length)];
    }
}
exports.StereoPlanRouteMock = StereoPlanRouteMock;
